import { Grid, List, ListItem, ListItemText, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import format from "date-fns/format";
import React from "react";
import { isMobile } from "react-device-detect";
import { FormattedMessage } from "react-intl";
import renderHTML from "react-render-html";
import { getContentFromHTML, getFirstElementFromHTML } from "utils/string-utils";

type History = {
	handleNoteSelect: any;
	selectedNote: any;
	notes;
	handleEditNoteFeature: any;
};

const NoteHistory: React.FC<History> = ({ handleNoteSelect, selectedNote, notes, handleEditNoteFeature }) => {
	const classes = useStyles();
	return (
		<Grid item className={classes.container} xs={4}>
			{notes.length > 0 ? (
				<List className={classes.listContainer}>
					{notes?.map((note, index) => {
						const { primaryContent, secondaryContent } = getContent(note);

						return (
							<React.Fragment key={note._id}>
								<ListItem
									className={
										note._id === selectedNote?._id ? classes.selectedListItem : classes.listItem
									}
									onClick={(e) => {
										handleNoteSelect(note._id);
										if (isMobile) handleEditNoteFeature();
									}}
								>
									<ListItemText
										id={"section-existing-note-" + index}
										classes={{
											primary: classes.primaryText,
											secondary: classes.secondaryText,
										}}
										primary={primaryContent}
										secondary={secondaryContent}
									/>
								</ListItem>
							</React.Fragment>
						);
					})}
				</List>
			) : (
				<Typography sx={{ fontSize: "0.875rem", textAlign: "center", fontWeight: 600 }}>
					<FormattedMessage id="NOTES.no-notes" defaultMessage="No notes" />
				</Typography>
			)}
		</Grid>
	);
};

const isToday = (someDate: Date) => {
	const today = new Date();
	return (
		someDate.getDate() === today.getDate() &&
		someDate.getMonth() === today.getMonth() &&
		someDate.getFullYear() === today.getFullYear()
	);
};

const getFormattedDate = (date: string, text) => {
	const noteDate = new Date(date);
	const str = isToday(noteDate) ? "Today" : format(new Date(date), "dd-MM-yy");
	return renderHTML(
		`<span><b>${str}</b></span> <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${text}</span>`,
	);
};

const getContent = (note): { primaryContent: string; secondaryContent: any } => {
	let primaryContent: string = getFirstElementFromHTML(note.text, "New Note");
	let restOfLines: string = getContentFromHTML(note.text);
	let secondaryContent = <>{getFormattedDate(note.updatedAt, !!restOfLines ? restOfLines : "No additional text")}</>;
	return { primaryContent, secondaryContent };
};

const useStyles = makeStyles((theme: Theme) => ({
	container: {
		borderRight: "3px solid #dbd7d7",
		padding: "20px",
		width: "100%",
		height: "100%",
		[theme.breakpoints.down("mobile")]: {
			flexBasis: "100%",
			maxWidth: "100%",
		},
	},
	listItem: {
		cursor: "pointer",
		padding: "6px 8px",
		fontSize: "0.75rem",
		[theme.breakpoints.down("mobile")]: {
			borderRadius: 0,
			borderBottom: "1px solid #E4E5E9",
			"&:last-child": {
				borderBottom: "none",
			},
		},
	},
	selectedListItem: {
		cursor: "pointer",
		backgroundColor: "#823BEB1A",
		background: "#823BEB1A 0% 0% no-repeat padding-box",
		boxShadow: "0px 0px 10px #7777771A",
		borderRadius: "5px",
		padding: "6px 8px",
	},
	primaryText: {
		color: "#3C4255",
		font: "normal normal bold 14px Tahoma",
		paddingBottom: "4px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		fontSize: "0.75rem",
	},
	secondaryText: {
		color: "#3C4255",
		font: "normal normal normal 14px Tahoma",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		fontSize: "0.75rem",
	},
	divider: {
		color: "#823BEB1A",
		backgroundColor: "#823BEB1A",
	},
	selectedDivider: {
		display: "none",
	},
	notesHeader: {
		display: "flex",
		color: "#717171",
		font: "normal normal bold 12px/14px Tahoma",
		opacity: "1",
		marginBottom: "0.5rem",
	},
	fullWidth: {
		width: "100%",
	},
	fullHeight: {
		height: "100%",
	},
	listContainer: {
		width: "100%",
		// height: "100%",
		paddingTop: "0",
		paddingBottom: 0,
		[theme.breakpoints.down("mobile")]: {
			border: "1px solid #E4E5E9",
			borderRadius: "8px",
		},
	},
}));

export default NoteHistory;
